<template>
    <section class="d-flex flex-column justify-content-between align-content-center h-full">
        <div class="flex-grow-1 h-full scroll-y" ref="scrollBody">
            <div class="pda-default" v-if="dataLoadState && feedbackList.length === 0">
                <no-data></no-data>
            </div>

            <div class="mgt-14">
                <div v-for="(feedback, index) in feedbackList" :key="index">
                    <div class="d-flex flex-row justify-content-between pdt-13 pdb-13 mgl-8 mgr-8">
                        <member-profile :profile="feedback.member.profile" class="mgl-8 mgr-8">
                            {{feedback.member.name && feedback.member.name.fullName ? feedback.member.name.fullName.charAt(0).toUpperCase() : ''}}
                        </member-profile>

                        <div class="t-body1 flex-grow-1 mgr-8 mgl-8">
                            <div>
                                {{feedback.member.name ? feedback.member.name.fullName : $t("S10082")}}
                                <span class="t-caption t-color-content1 mgr-8 mgl-8" v-if="$moment(feedback.date).fromNow() === 'in 4 minutes'">
                                    {{'a few seconds ago'}}
                                    <!-- {{$moment(feedback.date).fromNow()}} -->
                                    <!-- {{$moment(feedback.date).format('YYYY-MM-DD HH:mm:ss').fromNow()}} -->
                                    <!-- {{getTime(feedback.date)}} -->
                                    <!-- {{feedback.date}} -->
                                </span>
                                <span class="t-caption t-color-content1 mgr-8 mgl-8" v-else>
                                    {{$moment(feedback.date).fromNow()}}
                                </span>
                                <!-- <span class="t-caption t-color-red1"  @click="deleteFeedback(feedback.id)">
                                    delete
                                </span> -->
                            </div>
                            <div class="t-body3 t-color-gray2 mgt-4">
                                {{feedback.text}}

                            </div>
                        </div>
                    </div>
                    <div>
                        <hr class="divider">
                    </div>
                </div>
                <div ref="scrollBottom"></div>
            </div>

        </div>
        <div>
            <form @submit.prevent="sendFeedback()" novalidate>
            <hr class="divider">
            <div class="d-flex flex-row justify-content-between align-items-center mgl-12 mgr-12 mgt-8 mgb-8 input-feedback">
                <div class="flex-grow-1 mgl-12 mgr-12">
                    <input type="text" :placeholder="$t('171')" v-model="text" class="t-body1"/>
                </div>
                <div>
                    <button class="mdc-icon-button" type="button" @click="sendFeedback()" :class="{'on': isText}" :disabled="!isText"></button>
                </div>
            </div>
            </form>
        </div>

    </section>

</template>

<script>
/**
 * 나의 학습 상세 - 미션 피드백 컴포넌트(my learning view - mission feedback component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import learnApi from '@/api/learnApi.js'
import NoData from '../../common/NoData.vue'
import MemberProfile from '../../common/MemberProfile.vue'

export default {
    data() {
        return {
            learnId: null,
            assignmentId: null,
            feedbackList: [],
            dataLoadState: false,
            text: '',
            DataFeedBackTime:'',
            currentTime:''
        }
    },
    components: {
        'no-data': NoData,
        'member-profile': MemberProfile
    },
    mounted() {
        this.learnId = this.$route.params.learnId,
        this.assignmentId = this.$route.params.assignmentId
        this.fatchData()
    },

    computed: {
        isText() {
            return !!this.text
        }
    },
    updated() {
        setTimeout(() => {
            this.moveScrollBottom()
        }, 100);

    },
    methods: {
        // 피드백 목록 API 호출(get feedback list data)

        fatchData() {
            let params = this.setParams()
           // this.$showLoading(this.$refs.scrollBody)
            learnApi.learnViewMissionFeedback(params).then((response) => {
               // this.$hideLoading(this.$refs.scrollBody)
                console.log('getFeedBackLesson', response.data.data)
                this.feedbackList = response.data.data
                this.dataLoadState = true
            })
        },

        // 피드백 등록 API 호출(regist feedback)
        sendFeedback() {
            let params = this.setParams()

            learnApi.learnViewMissionFeedbackSubmit(params).then((response) => {
                console.log('learnViewMissionFeedbackSubmit', response.data.data)
                this.fatchData()
                this.text = ''
            })

        },

        // 피드백 삭제 API 호출(delete feedback)
        deleteFeedback(feedbackId) {
            let params = {
                learnId: this.learnId,
                assignmentId: this.assignmentId,
                feedbackId: feedbackId
            }

            learnApi.learnViewMissionFeedbackDelete(params).then((response) => {
                console.log('learnViewMissionFeedbackDelete', response.data.data)
                this.fatchData()
            })

        },

        // 스크롤 바닥으로 이동(move scroll to bottom)
        moveScrollBottom() {
            let element = this.$refs.scrollBottom
            let options = {
                container: this.$refs.scrollBody,
                easing: 'ease-in'
            }
            this.$scrollTo(element, 100, options)
        },

        // 파라미터 설정(set parameter)
        setParams() {
            let params = {
                learnId: this.learnId,
                assignmentId: this.assignmentId,
                text: this.text
            }
            return params
        },
        getTime(date){
            this.DataFeedBackTime = this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
            this.currentTime = this.$moment(this.DataFeedBackTime).fromNow();
            if(this.currentTime === 'in 4 minutes'){
                return 'a few seconds ago';
            } else {
                return this.currentTime = this.$moment(this.DataFeedBackTime).fromNow();
            }
        }

    }
}
</script>
